<template>
    <div v-if="goodAnswersInARow > 0 && showMessage" class="game__body bg--layer-light text--center mb--md">
        <div class="game__body__inner">
            <div v-if="goodAnswersInARow === 7" class="game__success game__success--animate">
                <strong>Perfect game!</strong> 7 in a row
            </div>

            <div v-if="goodAnswersInARow === 6" class="game__success game__success--animate">
                <strong>Amazing!</strong> 6 in a row
            </div>

            <div v-if="goodAnswersInARow === 5" class="game__success game__success--animate">
                <strong>Excellent!</strong> 5 in a row
            </div>

            <div v-if="goodAnswersInARow === 4" class="game__success game__success--animate">
                <strong>Excellent!</strong> 4 in a row
            </div>

            <div v-if="goodAnswersInARow === 3" class="game__success game__success--animate">
                <strong>Great!</strong> 3 in a row
            </div>

            <div v-if="goodAnswersInARow === 2" class="game__success game__success--animate">
                <strong>Great!</strong> 2 in a row
            </div>

            <div v-if="goodAnswersInARow === 1" class="game__success game__success--animate">
                <strong>Good job!</strong>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            goodAnswersInARow: {
                default: 0,
            },

            showMessage: {
                default: false,
            }
        }
    }
</script>

<style scoped>

</style>